import { updateObject } from "../../../../shared";
import {
  globalConstants,
  individualStorePerformanceConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  ALL_USER_RESPONSE_DATA,
  GET_ALL_INTERNAL_NOTES,
  GET_CUSTOMER_CONVERSATIONS,
  RESET_CUSTOMER_CONVERSATION,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
} = individualStorePerformanceConstants;

const initialState = {
  allItemsForExport: [],
  userResponsesData: [],
  allUserResponsesData: [],
  userResponseDataPagination: {
    size: 10,
    number: -1,
    totalElements: 0,
  },
  allConversation: [],
  allInternalNotes: [],
  storesAvgSentimentAndTransactionRatingData: {},
};

export const individualStorePerformanceReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ALL_USER_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allUserResponsesData: action.data.pageData,
        userResponsesData: action.data.pageData.userResponses,
        userResponseDataPagination: action.data.page,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + SUCCESS:
      return updateObject(state, {
        allItemsForExport: action.data,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + FAILURE:
      return updateObject(state, { allItemsForExport: [] });
    case STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        storesAvgSentimentAndTransactionRatingData: action.data,
      });
    case GET_CUSTOMER_CONVERSATIONS + SUCCESS:
      return updateObject(state, {
        allConversation: [...state.allConversation, ...action.data.data],
      });
    case RESET_CUSTOMER_CONVERSATION + SUCCESS:
      return updateObject(state, {
        allConversation: [],
      });
    case GET_ALL_INTERNAL_NOTES + SUCCESS:
      return updateObject(state, {
        allInternalNotes: action.data.data,
      });
    default:
      return state;
  }
};
